export default [
    {
        variable: '--crumbs-color',
        variableProp: '#8D8D8D',
    },
    {
        variable: '--hovered-crumbs-color',
        variableProp: '#01000C',
    },
    {
        variable: '--scroll-behavior',
        variableProp: 'auto',
    },
];
